// Source: app/scripts/controllers/goods-types-controller.js
Auction.controller('GoodsTypesController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  function ($scope, $filter, $routeParams, $location, toaster, crudService, $modal, Downloader, Messages) {


    // $scope.downloadDocument = function () {
    //   if ($scope.chosenDocument.id) {
    //     Downloader.download('/data/rest/portal_attachments/get/' + $scope.chosenDocument.id);
    //   }
    // };


    $scope.modalAddOrEditDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_goods_type_template.html',
      show: false
    });

    $scope.addGoodsTypeAttachment = function(goodsType){
    console.log('tuka sum ');
    };
    // $scope.crudScope.addAuthorizationTypeAttachment = function(authorizationType){
    //   console.log('tuka sum vo crud');
    // };

    // $scope.changeAttachmentForDocument = function () {
    //   if ($scope.chosenDocument.id) {
    //     $scope.portalDocument = $scope.chosenDocument;
    //     $scope.modalAddOrEditCaseDocument.show();
    //   }
    // };

    // $scope.savePortalDocument = function () {
    //   caseService.getPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
    //     $scope.documentList = data;
    //   });
    //   $scope.modalAddOrEditCaseDocument.hide();
    //
    //   $scope.portalDocument = {};
    //
    // };
    //
    // $scope.showAddNewDocumentForm = function () {
    //   $scope.portalDocument = {};
    //   $scope.modalAddOrEditCaseDocument.show();
    // };

    $scope.afterInit = function (crudScope) {

      crudScope.addGoodsTypeAttachment = function(goodsType){
        console.log('tuka sum vo crud 2');
        $scope.goodsType = goodsType;
        $scope.modalAddOrEditDocument.show();
      };

      crudScope.downloadGoodsTypeTemplateAttachment = function (templateId) {
        if(templateId) {
          Downloader.download('/data/rest/portal_attachments/get_goods_type_template/' + templateId);
        }
      };
    }

  }
]);
